import React from 'react';
import { Icon } from 'antd';
import AvisLegal from './avisLegal';
import ConsentimentLocalStorage from './consentimentLocalStorage';

const Peu = () => (
    <div className='peu'>
        <span className='mailto'><Icon type='mail' /><a href='mailto:xom.meteocat@gencat.cat'>xom.meteocat@gencat.cat</a></span>
        <AvisLegal />
        <span className='footer-copy'>&copy; Servei Meteorològic de Catalunya</span>
        <ConsentimentLocalStorage />
    </div>
);

export default Peu;



// WEBPACK FOOTER //
// ./src/components/peu/peu.js